module.exports = __webpack_public_path__ + "img/exp_step.e2504096.png";